import React, {Fragment, useMemo, useCallback, useEffect, useContext} from "react";
import store from "../../store";
import {useDispatch} from 'react-redux'
import { clear_memberships, clear_selected_membership } from '../../features/membership/membershipSlice';
import { clear_addons, clear_selected } from '../../features/addons/addonsSlice';
import { clear_logged_in_user } from "../../features/logged_in_user/loggedInUserSlice";
import { clear_guardian } from '../../features/golfer/golferSlice';
import {useNavigate} from "react-router-dom";
import {JoinPageContext} from "../../context/join_page_context";

export default function Pending() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { JoinPageData } = useContext(JoinPageContext)

    const clearData = useCallback(() => {
    dispatch(clear_logged_in_user())
    dispatch(clear_guardian());
    dispatch(clear_addons());
    dispatch(clear_selected());
    dispatch(clear_memberships());
    dispatch(clear_selected_membership());
  }, [dispatch])

    const data = useMemo(() => {
    const store_data = store.getState();
    const values = {
      club_data: store_data.club.club_data,
      payment: store_data.payment.payment,
      golfer_data: store_data.golfer.golfer,
      address: store_data.golfer.address
    };
    clearData();

    return values
  }, [clearData])

  const membership = data.payment.membership;
  const addons = data.payment.addons;
  const club_data = data.club_data;
  const golfer = data.golfer_data;
  const total_amount = membership.amount + membership.transaction_fee + addons.reduce( ( sum, addon ) => sum + parseFloat(addon.amount) , 0);

  const getNavigationPath = () => {
    const slice_end = sessionStorage.getItem('entered_from_assoc_level') === 'true' ? 4 : 6;
    return window.location.href.split('/').slice(0, slice_end).join('/');
  }

  return (
    <Fragment>
      <h1 className="page-title">
        Your registration has been submitted!
      </h1>
      <div className="payment-membership-title center_horizontal_margin top-margin large_bottom_margin">
        <div className="center_horizontal_margin">
          <div className="line-height-18" style={{ width: "90%", margin: "auto" }}>
            <p className="med_bottom_margin">
              Dear {`${golfer.first_name} ${golfer.last_name},`}
            </p>
            <p className="med_bottom_margin">
              Thank you for your interest in the {club_data.name}!
            </p>
            <p className="med_bottom_margin">
              Your registration is <strong>pending approval.</strong>
            </p>
            <p className="med_bottom_margin">
              Once approved, a charge of <span className="semi-bold">${parseFloat(total_amount).toFixed(2)}</span> will be applied to the payment method that you provided during registration.
            </p>
            <p className="large_bottom_margin">
              You will receive a separate email at that time confirming transaction and membership details.
            </p>
            <table className="receipt-table">
              <tbody>
              <tr>
                <th>{membership.name}</th>
                <td>${membership.amount.toFixed(2)}</td>
              </tr>
              {addons.map((addon, index) => (
                <tr key={index}>
                  <th>{addon.name}</th>
                  <td>${parseFloat(addon.amount).toFixed(2)}</td>
                </tr>
              ))}
                <tr>
                  <th>{"Transaction Fee"}</th>
                  <td>${membership.transaction_fee.toFixed(2)}</td>
                </tr>
              <tr>
                <th style={{verticalAlign: "middle"}}>Total:</th>
                <td className="semi-bold">${parseFloat(total_amount).toFixed(2)}
                  <p className="pending-approval">Pending Approval</p>
                </td>
              </tr>
              </tbody>
            </table>
            <br/>
            <p className="large_bottom_margin">
              If you have any questions, please contact {club_data.primary_contact} at the {club_data.name}.
            </p>
            <p>
              {club_data.email}
            </p>
            <p className="large_bottom_margin">
              {club_data.phone}
            </p>
            <button
              className="btn fit fill cardinal centered_btn"
              onClick={() => {window.location.replace(getNavigationPath())}}
            >
              Return to {sessionStorage.getItem('entered_from_assoc_level') === 'true' ? JoinPageData.golf_association_details.name : club_data.name}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
